module.exports = __webpack_public_path__ + "static/media/markalar-icon2.f677dde3.png";